import { Popover } from "@headlessui/react";
import { X } from "phosphor-react";

export function CloseButton() {
  return (
    <Popover.Button
      title="Fechar formulário de feedback"
      aria-label="Fechar formulário de feedback"
      className="text-zinc-400 hover:text-zinc-100 cursor-pointer transition-colors"
    >
      <X weight="bold" className="w-4 h-4" />
    </Popover.Button>
  );
}
